<template>
	<div>
		<b>{{label || ''}}</b>
		<br>
		<!-- zona y seleccion de imagen para subir -->
		<div v-cloak @drop.prevent="addFile" @dragover.prevent class="zoneDrop" v-if="!disabled && !(!multiple && (imgs.length || loadingFiles.length || item.preview.srcs.length))">
			<h3>
				<v-icon>cloud_upload</v-icon>
				<span> Subir imagenes (Arrastrar aquí). Solo png, jpeg y jpg.</span>
			</h3>
			<label :for="'file-upload-task'+id" class="custom-file-upload custom-primary-btn">
				<v-icon>add</v-icon>
				<span> Seleccionar</span>
				<input :id="'file-upload-task'+id"
					class="btn"
					multiple
					type="file"
					accept="image/png, image/jpeg, image/jpg"
					@change="selectFile($event.target.files)">
			</label>
		</div>

	
			<!-- imagen que se estan cargando para subir -->
			<div v-for="(fileName, i) in loadingFiles"
				:key="i+'loading'"
				class="imgContainer main-border-color">
				<v-progress-circular style="width: 120px;height:120px"
					:width="3"
					color="#F67B2F"
					indeterminate/>
				<div style="padding:9px;">Cargando {{fileName}}...</div>
			</div>
			<!-- imagen que se cargo y se quiere subir -->
			<div v-for="(src, i) in item.preview.srcs"
				class="imgContainer main-border-color"
				:key="i+'prev'">
				<img :src="src"/>
				<v-btn class="main-color"
					@click="removePreview(i)">
					<v-icon>delete</v-icon>
					<span>Quitar</span>
				</v-btn>
			</div>
		<!-- imagen que ya esta subida -->
		<div v-for="(img, i) in imgs"
			class="imgContainer"
			:key="(img.id || i)+'imgs'">
			<v-progress-circular
				v-if="is_img_blob_loading(img)"
				style="width: 120px;height:120px"
				:width="3"
				color="#F67B2F"
				indeterminate/>
			<img v-else-if="imgDisplaySrc(img)" :src="imgDisplaySrc(img)"/>
			<v-btn v-if="!disabled" @click="removePhoto(img)">
				<v-icon>delete</v-icon>
				<span>Quitar</span>
			</v-btn>
			<v-btn v-else color="primary" @click="open_saved_img(img)">
				<v-progress-circular v-if="is_auth_file_opening(img)" indeterminate color="primary" size="16" width="2"/>
				<template v-else>
					<v-icon>insert_drive_file</v-icon>
					<span>Ver</span>
				</template>
			</v-btn>
		</div>
	</div>
</template>

<script>
/* 
	single 
obj.key = file
	multiple
obj = [
	{key:file}
]
*/
//import {uuid as uuidv4} from 'uuid';
//import {v4 as uuid} from 'uuid';
import {v4 as uuid} from 'uuid';
import { buildAuthFileUrl, fetchAuthenticatedFileBlobUrl } from '@/functions/openAuthenticatedPrtFile';
import { ENDPOINT_ACTION_PHOTOGRAPHIC_RECORD } from '@/config';
import open_auth_file from '@/mixins/open_auth_file';
export default {
	mixins: [open_auth_file],
	props: ['multiple', 'container', 'c_key', 'label', 'disabled','on_remove','on_add','auth_file_endpoint'],
  data() {
    return {
			id: uuid(),
			loadingFiles: [],
			preview: { files: [], srcs: []},
			blobSrcs: {},
			blobLoading: {},
    };
  },
  computed: {
		imgs(){
			if (!this.container) return [];
			const isSaved = (m) => m && m.id && typeof m[this.c_key] === 'string';
			return this.multiple
				? this.container.filter(isSaved)
				: (isSaved(this.container) ? [this.container] : []);
		},
		countImgs() { return this.multiple ? this.item.preview.srcs.length + this.item.imgs.length : 1 },
    item() {
			//si es single, el container sera un {}
			//si es multiple ya vendra como []
			const {preview} = this;
			return this.multiple
				? {img: this.container, preview}
				: {img: [this.container], preview};
		},
	},
	watch: {
		container: {
			immediate: true,
			deep: true,
			handler() {
				this.loadAuthenticatedImgs(this.imgs);
			},
		},
	},
	beforeDestroy() {
		Object.keys(this.blobSrcs).forEach((id) => this.revokeBlob(id));
	},
  methods: {
    addFile(e) {
			let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles.length) return;
      this.selectFile(droppedFiles);
    },
		imgDisplaySrc(img) {
			if (img && img.id && this.blobSrcs[img.id]) return this.blobSrcs[img.id];
			const src = img && img[this.c_key];
			if (typeof src === 'string' && src.includes('/uploads/')) return '';
			if (this.resolveAuthUrl(img)) return '';
			return src || '';
		},
		is_img_blob_loading(img) {
			return !!(img && img.id && this.resolveAuthUrl(img) && !this.blobSrcs[img.id] && this.blobLoading[img.id] !== false);
		},
		resolveAuthUrl(img) {
			const endpoint = this.auth_file_endpoint || ENDPOINT_ACTION_PHOTOGRAPHIC_RECORD;
			return buildAuthFileUrl(endpoint, img && img.id);
		},
		revokeBlob(id) {
			if (!id || !this.blobSrcs[id]) return;
			URL.revokeObjectURL(this.blobSrcs[id]);
			this.$delete(this.blobSrcs, id);
		},
		async loadAuthenticatedImg(img) {
			const url = this.resolveAuthUrl(img);
			if (!img || !img.id || !url) return;
			if (this.blobSrcs[img.id] || this.blobLoading[img.id]) return;
			this.$set(this.blobLoading, img.id, true);
			try {
				if (!await this.assignAccess()) throw new Error('no se pudo obtener acceso');
				const blobUrl = await fetchAuthenticatedFileBlobUrl(url);
				this.$set(this.blobSrcs, img.id, blobUrl);
			} catch (e) {
				this.getError(e);
			} finally {
				this.$set(this.blobLoading, img.id, false);
			}
		},
		loadAuthenticatedImgs(imgs) {
			const list = imgs || [];
			list.forEach((img) => this.loadAuthenticatedImg(img));
		},
		open_saved_img(img) {
			if (img && img.id && this.blobSrcs[img.id]) {
				window.open(this.blobSrcs[img.id], '_blank', 'noopener,noreferrer');
				return;
			}
			if (!this.resolveAuthUrl(img)) return;
			return this.open_auth_file(img);
		},
		removePreviewFor(file, src) {
			const preview = this.preview;
			if (src) {
				const si = preview.srcs.indexOf(src);
				if (si >= 0) preview.srcs.splice(si, 1);
			}
			if (file) {
				const fi = preview.files.indexOf(file);
				if (fi >= 0) preview.files.splice(fi, 1);
			}
		},
		selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
			const filteredFiles = [];
			for (let f of files) {
				if (['image/jpg','image/png','image/jpeg'].includes(f.type)) filteredFiles.push(f);
			}
			if (!filteredFiles.length) return;

			const item = this.item;
			const { multiple, c_key, on_add } = this;

			filteredFiles.forEach((file) => {
				this.loadingFiles.push(file.name);
				item.preview.files.push(file);
				if (!on_add) {
					if (multiple) {
						const pending = {};
						pending[c_key] = file;
						item.img.push(pending);
					} else {
						item.img[0][c_key] = file;
					}
				}

				const reader = new FileReader();
				reader.onload = (e) => {
					const src = e.target.result;
					const loadingIdx = this.loadingFiles.indexOf(file.name);
					if (loadingIdx >= 0) this.loadingFiles.splice(loadingIdx, 1);
					item.preview.srcs.push(src);

					const removeThisPreview = () => this.removePreviewFor(file, src);
					if (on_add) {
						on_add(file, {
							preview: item.preview,
							file,
							src,
							removePreview: removeThisPreview,
						});
					}
				};
				reader.readAsDataURL(file);
			});

			const input = document.getElementById('file-upload-task' + this.id);
			if (input) input.value = '';
		},
		removePreview(i) {
			if (this.on_remove) return;//cuando esta ese metodo, las imgs se borran en el metodo removePhoto, ya q las preview son borradas luego de ser guardadas
			this.item.preview.files.splice(i, 1);
			this.item.preview.srcs.splice(i, 1);
		},
		removePhoto(img) {
			if (img && img.id) this.revokeBlob(img.id);
			if (this.on_remove) this.on_remove(img);
			return this.multiple
				? this.container.splice(this.container.indexOf(img), 1)
				: this.container[this.c_key] = null;
		},
  },
};
</script>

<style scoped>
.zoneDrop {
  text-align: center;
  border:dashed 1px grey;
  margin: 10px;
  width: 244px;
  height: 165px;
  padding: 2px;
  display: inline-block;
  border-radius: 3px;
}


.zoneDrop > h3{
  margin-top: 10px;
  display: block;
  height: 103px;
}
.imgContainer {
  margin: 10px;
  display: inline-block;
  border:solid 1px;
  padding:2px;
  border-radius: 3px;
  text-align: center;
}
.imgContainer img{
  width: 240px;
  height: 120px;
  display:block;
}
.imgContainer button{
  margin: 2px;
}
</style>
